import React, { useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Typography,
  Button,
} from "@mui/material";

const PaymentCardForm = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);

  // Format card number as XXXX XXXX XXXX XXXX
  const formatCardNumber = (value) => {
    return value
      .replace(/\D/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };

  // Detect card type
  const getCardType = (number) => {
    const firstDigit = number[0];
    if (/^4/.test(number)) return "Visa";
    if (/^5[1-5]/.test(number)) return "MasterCard";
    if (/^3[47]/.test(number)) return "American Express";
    if (/^6/.test(number)) return "Rupay";
    return "";
  };

  const cardType = getCardType(cardNumber.replace(/\s/g, ""));

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 3 }}>
      {/* Card Preview */}
      <Box
        sx={{
          perspective: "1000px",
          mb: 3,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: 200,
            transformStyle: "preserve-3d",
            transition: "transform 0.8s",
            transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front Side */}
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              background: "linear-gradient(135deg, #1e3c72, #2a5298)",
              color: "#fff",
              borderRadius: "20px",
              boxShadow: 4,
              p: 3,
            }}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Credit Card</Typography>
              {cardType && (
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", textTransform: "uppercase" }}
                >
                  {cardType}
                </Typography>
              )}
            </Grid>

            <Typography variant="h5" sx={{ letterSpacing: 2, mt: 4, mb: 3 }}>
              {cardNumber || "**** **** **** ****"}
            </Typography>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Typography variant="subtitle2">Card Holder</Typography>
                <Typography variant="body1">
                  {cardName || "YOUR NAME"}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="subtitle2">Expires</Typography>
                <Typography variant="body1">{expiry || "MM/YY"}</Typography>
              </Grid>
            </Grid>
          </Box>

          {/* Back Side */}
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              background: "linear-gradient(135deg, #232526, #414345)",
              color: "#fff",
              borderRadius: "20px",
              boxShadow: 4,
              p: 3,
              transform: "rotateY(180deg)",
            }}
          >
            <Box
              sx={{
                background: "#000",
                height: 40,
                mb: 3,
                borderRadius: "6px",
              }}
            />
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              CVV
            </Typography>
            <Box
              sx={{
                background: "#fff",
                color: "#000",
                borderRadius: "6px",
                width: "100px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              {cvv || "***"}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Form Fields */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Card Number"
            fullWidth
            value={cardNumber}
            onChange={(e) => setCardNumber(formatCardNumber(e.target.value))}
            inputProps={{ maxLength: 19 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Card Holder Name"
            fullWidth
            value={cardName}
            onChange={(e) => setCardName(e.target.value.toUpperCase())}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Expiry Date (MM/YY)"
            fullWidth
            value={expiry}
            onChange={(e) => setExpiry(e.target.value)}
            inputProps={{ maxLength: 5 }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="CVV"
            fullWidth
            type="password"
            value={cvv}
            onChange={(e) => setCvv(e.target.value)}
            inputProps={{ maxLength: 3 }}
            onFocus={() => setIsFlipped(true)}
            onBlur={() => setIsFlipped(false)}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{ mt: 2, borderRadius: "10px" }}
          >
            Pay Now
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentCardForm;
